enum Service {
  SET_SERVICE_INITIALIZE = 'SET_SERVICE_INITIALIZE',
  SET_SERVICE_LIST = 'SET_SERVICE_LIST',
  SET_SERVICE_INFO = 'SET_SERVICE_INFO'
}

export default Service;
